import { SUBSCRIPTION_ROUTES } from '../homeDashboard/subscription/subscriptionRoutes';

export function paidQuestionBlocked(question = {}) {
  const paid = String(question.free_paid ?? question.freePaid ?? question.raw?.free_paid ?? '').toUpperCase();
  const status = Number(question.paymentStatus ?? question.payment_status ?? question.raw?.payment_status ?? 0);
  return paid ? paid === 'P' && status !== 1 : Boolean(question.isPaidBlocked || question.isLocked);
}

export function questionSubscriptionTarget(question, context = {}, metadata = {}) {
  const sources = [question?.raw || {}, question || {}, context, metadata];
  const get = (...keys) => {
    for (const source of sources) for (const key of keys) {
      if (Object.prototype.hasOwnProperty.call(source, key) && source[key] !== undefined && source[key] !== '') return source[key];
    }
    return undefined;
  };
  const positive = (...keys) => {
    for (const source of sources) for (const key of keys) {
      if (Number.isSafeInteger(Number(source[key])) && Number(source[key]) > 0) return Number(source[key]);
    }
    return 0;
  };
  const stateId = positive('stateId', 'states_id', 'state_id');
  const subjectId = positive('subjectId', 'subject_id');
  const categoryId = positive('categoryId', 'category_id', 'quest_category_id') || 2;
  const examId = positive('examId', 'exam_id');
  if (examId > 0) {
    const planId = positive('examPlanId', 'exam_plan_id', 'planId', 'plan_id');
    const duration = get('planDurationId', 'plan_duration_id', 'durationId', 'duration_id');
    const durationId = duration == null ? null : Number(duration);
    return { pathname: planId > 0 ? SUBSCRIPTION_ROUTES.examDetail : SUBSCRIPTION_ROUTES.examPlans,
      state: { stateId, examId, examPlanId: planId, planDurationId: durationId,
        ...(planId > 0 ? { planId, durationId } : {}) } };
  }
  return { pathname: SUBSCRIPTION_ROUTES.subjectPlans, state: { stateId, subjectId, categoryId, tab: 'selectPlan' } };
}
